// "ResizeObserver loop limit exceeded" / "...completed with undelivered
// notifications" are benign browser notices: a ResizeObserver callback changed
// the layout so the observer had to run again, and the browser couldn't deliver
// every notification in the same frame. Nothing actually breaks, but it gets
// reported as an uncaught error (and the dev-server overlay surfaces it).
//
// Prevent it at the source: wrap ResizeObserver so each callback runs in the next
// animation frame. That breaks the synchronous observe -> layout -> observe loop
// the browser complains about, while leaving real errors untouched. Imported
// first in the application pack so the wrap is in place before any observer is
// created.
//
// The wrapper composes the native ResizeObserver instead of `class extends`-ing
// it. SWC transpiles to ES5 (browserslist "defaults" includes Opera Mini), and a
// subclass of a native DOM constructor becomes a `Native.call(this)` helper at
// ES5 — which throws "Failed to construct 'ResizeObserver': ... cannot be called
// as a function" because native constructors require `new`. Composition sidesteps
// that entirely.
const NativeResizeObserver = window.ResizeObserver;

if (NativeResizeObserver) {
  window.ResizeObserver = function ResizeObserver(callback) {
    return new NativeResizeObserver((entries, observer) => {
      window.requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  };
}
